import { Box, Link, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import type {
  PolymorphicLinkProps,
  PolymorphicTypographyProps,
} from "../../types";

const TABLET_BREAKPOINT = 640;

const LEGAL_MAX_WIDTH = 1040;

export const SocialRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 24,
  marginBottom: 42,
  [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
    justifyContent: "flex-start",
  },
}));

export const SocialList = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 20,
});

export const SocialLink = styled(Link)<PolymorphicLinkProps>(({ theme }) => ({
  display: "inline-flex",
  color: theme.palette.text.secondary,
  transition: theme.transitions.create("color", { duration: 160 }),
  "&:hover": {
    color: theme.palette.text.primary,
  },
  "& svg": {
    width: 18,
    height: 18,
    display: "block",
  },
}));

export const FinePrintRow = styled(Typography)<PolymorphicTypographyProps>(
  ({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 16,
    fontSize: 12.5,
    margin: "0 0 18px",
    color: theme.palette.text.disabled,
  })
);

export const FinePrintLink = styled(Link)<PolymorphicLinkProps>(
  ({ theme }) => ({
    fontSize: "inherit",
    textDecoration: "none",
    color: theme.palette.text.secondary,
    transition: theme.transitions.create("color", { duration: 160 }),
    "&:hover": {
      color: theme.palette.text.primary,
    },
  })
);

export const Copyright = styled("span")(({ theme }) => ({
  color: theme.palette.text.disabled,
}));

export const LegalText = styled(Typography)<PolymorphicTypographyProps>(
  ({ theme }) => ({
    fontSize: 11.5,
    lineHeight: 1.6,
    margin: 0,
    maxWidth: LEGAL_MAX_WIDTH,
    color: theme.palette.text.disabled,
  })
);
